const Languages = [
  {
    id: "1",
    Language: "Assamese",
  },
  {
    id: "2",
    Language: "Bangla",
  },
  {
    id: "3",
    Language: "Bengali",
  },
  {
    id: "4",
    Language: "Bodo",
  },
  {
    id: "5",
    Language: "Dogri",
  },
  {
    id: "6",
    Language: "Gujarati",
  },
  {
    id: "7",
    Language: "Hindi",
  },
  {
    id: "8",
    Language: "Kashmiri",
  },
  {
    id: "9",
    Language: "Kannada",
  },
  {
    id: "10",
    Language: "Konkani",
  },
  {
    id: "11",
    Language: "Maithili",
  },
  {
    id: "12",
    Language: "Malayalam",
  },
  {
    id: "13",
    Language: "Manipuri",
  },
  {
    id: "14",
    Language: "Marathi",
  },
  {
    id: "15",
    Language: "Nepali",
  },
  {
    id: "16",
    Language: "Oriya",
  },
  {
    id: "17",
    Language: "Punjabi",
  },
  {
    id: "18",
    Language: "Tamil",
  },
  {
    id: "19",
    Language: "Telugu",
  },
  {
    id: "20",
    Language: "Santali",
  },
  {
    id: "21",
    Language: "Sindhi",
  },
  {
    id: "22",
    Language: "Sanskrit",
  },
  {
    id: "23",
    Language: "Urdu",
  },
  {
    id: "24",
    Language: "English",
  },
];

export default Languages;
